import React from 'react';
import {classNames} from '@utils/class-names';
import ArticleCard from './article-card';
import {ArticleSearchResultDto} from "../../core/models/interfaces/article-search-result-dto.interface";
import {UniversalClickHandler} from "@common/models/types/universal-click-handler.type";

interface ArticleListProps {
    articles: Array<ArticleSearchResultDto | null>;
    className?: string;
    onClick?: UniversalClickHandler<void, ArticleSearchResultDto>;
    showActionsCard?: boolean;
    isArticleSelected?: (articleId: string) => boolean;
}

const ArticleList: React.FC<ArticleListProps> = (props: ArticleListProps) => {
    const {
        articles,
        className = '',
        onClick,
        showActionsCard,
        isArticleSelected,
    } = props;

    return (
        <div className={classNames('space-y-4', className)}>
            {articles.map((article) => article && (
                <ArticleCard
                    key={article.id}
                    article={article}
                    onClick={onClick}
                    showActions={showActionsCard}
                    isSelected={isArticleSelected?.(article.id)}
                />
            ))}
        </div>
    );
};

export default ArticleList;
